// Should we just delete this?
import React from 'react'
import { AppStatus, ModalName, useAppSelector } from '@/redux'
import { APIClient } from '@/services'
import { navigate } from 'gatsby'
import { Alert } from '@/components'
import { onUpdate, useI18N } from '@codeleap/common'
import { useLocation } from '@reach/router'
import { ReauthenticationStore } from '@/utils'
import { useAuthState } from '@/features/Auth/bridge/useAuthState'
import { logout } from '@/features/Auth/session/logout'
import { missingFrom } from '@/features/Auth/machine/completion'
import { nextCompletionStep } from '@/features/Auth/session/completionRoutes'

const authValidators = [
  'login',
  'signup',
  'aboutJob',
  'aboutYou',
  'verifyEmailAfter',
  'verifyEmailBefore',
  'success',
  'onboarding',
  'loading',
  'done'
]

export const ProfileRedirectModal = () => {
  const authModelOpen = useAppSelector(state => {
    const modals = state?.AppStatus?.modals
    const open = Object?.keys(modals)?.find(modal => authValidators.includes(modal) && modals?.[modal] === true)
    return !!open
  })

  const status = useAppSelector(state => state?.AppStatus?.status)
  const visible = useAppSelector(state => state?.AppStatus?.modals?.profileRedirect)

  const { isLoggedIn } = useAuthState()
  const { data: profile } = APIClient.Session.useProfile()

  const location = useLocation()
  const { t } = useI18N()

  const redirect = async () => {
    // The `modal` branch that used to stand here was unreachable: `checkSignupCompletion`
    // never returned one — the only code that would have set it was commented out — so
    // `isReauthentication` decided nothing. It is gone with the function it depended on.
    const nextStep = nextCompletionStep(missingFrom(profile))

    if (nextStep) {
      navigate(`/auth/${nextStep}/`)
    }

    AppStatus.setModal('profileRedirect')
  }

  const dismiss = async () => {
    await logout()
    AppStatus.setModal('profileRedirect')
  }

  // onUpdate(() => {
  //   if (!!isLoggedIn) {
  //     const checkProfile = async () => {
  //       AppStatus.setModal(['profileRedirect', false])

  //       const { isComplete } = await APIClient.Session.checkSignupCompletion(profile)

  //       const isAuthRoute = authValidators?.find(route => location?.pathname?.includes?.(route))

  //       if (!isComplete && !isAuthRoute) {
  //         AppStatus.setModal(['profileRedirect', true])
  //       }
  //     }

  //     checkProfile()
  //   }
  // }, [location?.pathname, isLoggedIn, profile, authModelOpen])

  return (
    <Alert
      visible={visible && isLoggedIn && !authModelOpen && !(status === 'loading' || status === 'done')}
      title={t('profileRedirectModal.title')}
      body={t('profileRedirectModal.body')}
      type={'warn'}
      toggle={() => null}
      closable={false}
      debugName={'Profile redirect modal'}
      onAction={redirect}
      onDismiss={dismiss}
      actionButtonProps={{
        text: t('profileRedirectModal.continue'),
        debugName: 'Profile edit check password change email alert modal - done on press',
        variants: ['flex', 'large', 'pill', 'paddingHorizontal:2']
      }}
      dismissButtonProps={{
        text: t('profileRedirectModal.dismiss'),
        debugName: 'Profile edit check password change email alert modal - done on press',
        variants: ['flex', 'outline', 'large', 'pill', 'paddingHorizontal:2']
      }}
    />
  )
}
